module.exports = __webpack_public_path__ + "static/media/case5C.cb26864.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case5C.mp4
// module id = QIGs
// module chunks = 0